// ARQUIVO ATUALIZADO
import React from 'react';
import Modal from '../ui/Modal';
// --- INÍCIO DA ALTERAÇÃO: Importando do novo arquivo de avatares ---
import { avatars } from '../../utils/avatars';
// --- FIM DA ALTERAÇÃO ---

const AvatarSelectionModal = ({ isOpen, onClose, onSelect }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Escolha seu novo Avatar"
            maxWidth="max-w-xl"
        >
            <div className="grid grid-cols-4 sm:grid-cols-4 gap-4 p-4"> {/* Ajustado para 4 colunas */}
                {avatars.map((avatarSrc, index) => (
                    <button
                        key={index}
                        onClick={() => onSelect(avatarSrc)}
                        className="aspect-square bg-white/5 dark:bg-white/5 rounded-full flex items-center justify-center transition-transform duration-200 hover:scale-110 hover:ring-2 ring-indigo-400 focus:outline-none focus:ring-2 ring-indigo-500"
                    >
                        <img src={avatarSrc} alt={`Avatar ${index + 1}`} className="w-full h-full rounded-full object-cover" />
                    </button>
                ))}
            </div>
        </Modal>
    );
};

export default AvatarSelectionModal;